// Glide.js
import Glide from "@glidejs/glide"
import "./form"
const menu = document.querySelector(".navigation-overlay")
const button = document.querySelector(".navigation-actions__menu-button")
const close = document.querySelector(".navigation-overlay__close")

button.addEventListener("click", () => {
	menu.classList.toggle("navigation-overlay--open")
})
close.addEventListener("click", () => {
	menu.classList.toggle("navigation-overlay--open")
})

// JavaScript to handle tab switching and animations
document.addEventListener("DOMContentLoaded", () => {
	const tabs = document.querySelectorAll(".tab-switcher__menu li")
	const contentItems = document.querySelectorAll(".tab-switcher__content li")

	tabs.forEach((tab, index) => {
		tab.addEventListener("click", () => {
			// Remove 'active' class from all tabs and content
			tabs.forEach((t) => t.classList.remove("active"))
			contentItems.forEach((c) => {
				c.classList.remove("active")
				c.classList.remove("fade-in") // Reset animation class
			})

			// Add 'active' class to the clicked tab and corresponding content
			tab.classList.add("active")
			contentItems[index].classList.add("active")
			contentItems[index].classList.add("fade-in") // Trigger fade-in animation
		})
	})
})

// JavaScript to handle tab switching and animations
document.addEventListener("DOMContentLoaded", () => {
	const tabs = document.querySelectorAll(".tab-switcher-alt__menu li")
	const contentItems = document.querySelectorAll(".tab-switcher-alt__content li")

	tabs.forEach((tab, index) => {
		tab.addEventListener("click", () => {
			// Remove 'active' class from all tabs and content
			tabs.forEach((t) => t.classList.remove("active"))
			contentItems.forEach((c) => {
				c.classList.remove("active")
				c.classList.remove("fade-in") // Reset animation class
			})

			// Add 'active' class to the clicked tab and corresponding content
			tab.classList.add("active")
			contentItems[index].classList.add("active")
			contentItems[index].classList.add("fade-in") // Trigger fade-in animation
		})
	})
})

// Scrollspy animation functionality
document.addEventListener("DOMContentLoaded", () => {
	// Get all elements with animation classes
	const animatedElements = document.querySelectorAll(
		".animate-fade-up, .animate-fade-down, .animate-fade-left, .animate-fade-right, .animate-fade-in, [data-animation]"
	)

	if (animatedElements.length === 0) return

	// Create an Intersection Observer
	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				// If the element is in the viewport
				if (entry.isIntersecting) {
					// Add the active class to trigger animation
					entry.target.classList.add("animate-active")

					// Always unobserve after animation is triggered
					observer.unobserve(entry.target)
				}
			})
		},
		{
			// Options for the observer
			threshold: 0.15, // Element is considered "visible" when 15% is in viewport
			rootMargin: "0px 0px -50px 0px", // Triggers slightly before element enters viewport
		}
	)

	// Start observing each element
	animatedElements.forEach((element) => {
		// Add initial state class
		if (
			!element.classList.contains("animate-fade-up") &&
			!element.classList.contains("animate-fade-down") &&
			!element.classList.contains("animate-fade-left") &&
			!element.classList.contains("animate-fade-right") &&
			!element.classList.contains("animate-fade-in")
		) {
			// If using data-animation attribute
			if (element.dataset.animation) {
				element.classList.add(`animate-${element.dataset.animation}`)
			}
		}

		// Start observing
		observer.observe(element)
	})
})

// Statistics counter animation
document.addEventListener("DOMContentLoaded", function () {
	// Function to check if element is in viewport
	function isInViewport(element) {
		const rect = element.getBoundingClientRect()
		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		)
	}

	// Function to animate counting
	function animateCountUp(element) {
		const target = parseInt(element.getAttribute("data-count-target"))
		const duration = 2000 // 2 seconds
		const frameDuration = 1000 / 60 // 60fps
		const totalFrames = Math.round(duration / frameDuration)
		let frame = 0

		const counter = setInterval(() => {
			frame++
			const progress = frame / totalFrames
			const currentCount = Math.round(progress * target)

			if (frame === totalFrames) {
				element.textContent = target
				clearInterval(counter)
			} else {
				element.textContent = currentCount
			}
		}, frameDuration)
	}

	// Get all number elements
	const numberElements = document.querySelectorAll(".statistics__item-number-large")
	let animated = false

	// Check if elements are in viewport on scroll
	function checkScroll() {
		if (!animated && numberElements.length > 0 && isInViewport(numberElements[0])) {
			animated = true
			numberElements.forEach((element) => {
				animateCountUp(element)
			})
			// Remove scroll listener once animation has started
			window.removeEventListener("scroll", checkScroll)
		}
	}

	// Initial check and add scroll listener
	checkScroll()
	window.addEventListener("scroll", checkScroll)
})

// Testimonials slider - update with custom configuration
document.addEventListener("DOMContentLoaded", () => {
	const testimonialSlider = document.querySelector(".testimonials-slider")

	if (testimonialSlider) {
		const slider = new Glide(".testimonials-slider", {
			perView: 1,
			type: "carousel",
			gap: 0,
			autoplay: 10000, // Optional: auto-advance slides
			// Important settings for custom layout
			peek: { before: 0, after: 0 },
			// Disable default animations that might interfere with custom layout
			animationDuration: 400,
			rewind: true,
			pauseOnHover: true,
		}).mount()
	}
})

// Page slider initialization
document.addEventListener("DOMContentLoaded", () => {
	// Find all page slider instances on the page
	const pageSliders = document.querySelectorAll(".page-slider-glide")

	if (pageSliders && pageSliders.length) {
		// Initialize each slider with a unique identifier
		pageSliders.forEach((slider, index) => {
			// Add a unique identifier if not already present
			if (!slider.id) {
				slider.id = `page-slider-glide-${index}`
			}

			// Initialize Glide for each slider instance
			new Glide(`#${slider.id}`, {
				perView: 1,
				type: "carousel",
				gap: 20,
				autoplay: 7000,
				animationDuration: 600,
				rewind: true,
				pauseOnHover: true,
				breakpoints: {
					768: {
						gap: 10,
					},
				},
			}).mount()
		})
	}
})

document.addEventListener("DOMContentLoaded", function () {
	const headers = document.querySelectorAll(".vacancy__header")

	headers.forEach((header) => {
		header.addEventListener("click", function () {
			const toggle = this.querySelector(".vacancy__toggle")
			const expanded = toggle.getAttribute("aria-expanded") === "true"
			const target = document.getElementById(toggle.getAttribute("aria-controls"))

			toggle.setAttribute("aria-expanded", !expanded)
			target.hidden = expanded
		})
	})
})

// Insurers slider initialization
document.addEventListener("DOMContentLoaded", () => {
	const insurersSlider = document.querySelector(".insurers__slider")
	if (insurersSlider) {
		new Glide(".insurers__slider", {
			type: "carousel",
			perView: 4,
			autoplay: 3000,
			hoverpause: true,
			gap: 4,
			animationDuration: 1000,
			animationTimingFunc: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
			breakpoints: {
				768: {
					perView: 1,
				},
			},
		}).mount()
	}
})
